import React from 'react'
import './styles.css'
import Logo from '../../../assets/img/sobre-rodas.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from 'react-router-dom'


// `contained` centraliza o conteudo num container (home). Sem ele o header ocupa a largura toda,
// como a tela de Empresas espera (o seletor de cidade dela fica sobre o header).
function Header({ history, contained }) {
  return (
    <header className={`container-header${contained ? ' container-header-contained' : ''}`}>
      <div className='container-header-inner'>
        <button type='button' className='container-header-logo' onClick={() => history.push('/')} aria-label='Sobre Rodas, página inicial'>
          <img src={Logo} alt='Sobre Rodas' />
        </button>

        <nav className='container-header-provider-area' aria-label='Acesso'>
          <button type='button' className='header-link' onClick={() => history.push('/provider/login')}>
            <FontAwesomeIcon icon={faStore} aria-hidden='true' />
            <span className='header-link-text'>Área da oficina</span>
          </button>

          <button type='button' className='header-cta' onClick={() => history.push('/client/login')}>
            <FontAwesomeIcon icon={faUser} aria-hidden='true' />
            Entrar
          </button>
        </nav>
      </div>
    </header>
  )
}

export default withRouter(Header)
